module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_2000_Inactive@1x-5212bc0ebe06e8fcfcceb96ddb885d1e.png";